import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ModalController } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../services';
import { VariationsDishSelectorPage } from '../../../variations/variations-dish-selector/variations-dish-selector';
import { VariationsProductSelectorPage } from '../../../variations/variations-product-selector/variations-product-selector';
import { TPVServices } from '../../../tpv/services';
import { TranslateService } from '@ngx-translate/core';
import { PosComboPage } from '../../../components/pos/pos-combo/pos-combo';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the TpvTicketSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-select-select',
  templateUrl: 'takeaway-order-select-select.html',
})
export class TakeawayOrderSelectSelectPage {
  tag_selected_dish: any;
  tag_selected_product: any;
  subscription: Subscription;
  extras_bebidas: string = this.translate.instant('general-extras-bebidas');

  _todos: string = this.translate.instant('general-todos');
  _aperitivos: string = this.translate.instant('general-aperitivos');
  _primeros: string = this.translate.instant('general-primeros');
  _segundos: string = this.translate.instant('general-segundos');
  _postres: string = this.translate.instant('general-postres');
  _bebidas: string = this.translate.instant('general-bebidas');

  max_dishes: any;
  max_ings_prods: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public tpvServices: TPVServices,
    public translate: TranslateService,
    public modalCtrl: ModalController) {

    this.max_dishes = this.globals.checkLimitsByLicense('dishes', 'max_dishes');
    this.max_ings_prods = this.globals.checkLimitsByLicense('stock', 'ings_prods');

    if (this.max_dishes == -1) {
      this.max_dishes = undefined;
    }
    if (this.max_ings_prods == -1) {
      this.max_ings_prods = undefined;
    }

    //Dish
    this.subscription = this.takeawayServices.getTagDish().subscribe(message => {
      this.tag_selected_dish = message;
      this.elementsNoVisibleDish();
      this.elementsVisibleDish();
    });
    //Product
    this.subscription = this.takeawayServices.getTagProduct().subscribe(message => {
      this.tag_selected_product = message;
      this.elementsNoVisibleProduct();
      this.elementsVisibleProduct();
    });

    this.takeawayServices.section_order = this.translate.instant('general-todos');

  }

  elementsVisibleDish() {
    var elements = document.getElementsByClassName(this.tag_selected_dish.message) as HTMLCollectionOf<HTMLElement>;
    for (var i = 0, max = elements.length; i < max; i++) {
      elements[i].style.display = 'block';
    }
  }

  elementsNoVisibleDish() {
    var elements = document.getElementsByClassName('all') as HTMLCollectionOf<HTMLElement>;
    for (var i = 0, max = elements.length; i < max; i++) {
      elements[i].style.display = 'none';
    }
  }

  elementsVisibleProduct() {
    var elements = document.getElementsByClassName(this.tag_selected_product.message) as HTMLCollectionOf<HTMLElement>;
    for (var i = 0, max = elements.length; i < max; i++) {
      elements[i].style.display = 'block';
    }
  }

  elementsNoVisibleProduct() {
    var elements = document.getElementsByClassName('all') as HTMLCollectionOf<HTMLElement>;
    for (var i = 0, max = elements.length; i < max; i++) {
      elements[i].style.display = 'none';
    }
  }

  styleHeight() {
    //get height screen
    //var height = window.innerHeight - 75 - 150; //70 es la capcalera
    let styles = {

      'overflow': 'scroll',
    };
    return styles;
  }

  replaceTags(tags) {//Devuelve los elementos del array de tags como string i en minuscula
    if (tags) {
      tags = tags.toString().toLowerCase();
      return tags.replace(new RegExp(',', 'g'), ' ');
    }
  }

  ionViewDidLeave() {
    this.takeawayServices.order_tmp = [];
  }

  insertToTicketMenu(_name, _price, _delete, _count, _type, _uid, _section, element) {

    if (element.style == 'combo') {//COMBO
      let profileModal = this.modalCtrl.create(PosComboPage,
        {
          combo: element,
          origin: 'tk'
        });
      profileModal.onDidDismiss(data => { });
      profileModal.present();
    } else {//OTHERS
      this.takeawayServices.insertTable(_name, _price, _delete, _count, _type, _uid, _section, {});

      let toast = this.toastCtrl.create({
        message: _name + " " + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  insertToTicketProduct(product, _price, _delete, _count, _type, _uid, _section) {
    let _name = '';
    //Comprovamos que el producto tenga el idioma seleccionado
    if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
      _name = this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product);
      //caso extras para separar
      if (this.takeawayServices.section_menu_order === this.translate.instant('general-extras-bebidas')) {
        _name = _name + ' s.'
      }
      //insert in table
      this.takeawayServices.insertTable(_name, _price, _delete, _count, _type, _uid, _section, product);

    } else {
      this.takeawayServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, _section, product);
      _name = 'no name - ' + _price;
    }

    let toast = this.toastCtrl.create({
      message: _name + ' añadido correctemente',
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }



  insertToTicketDish(dish, _price, _delete, _count, _type, _uid, _section) {
    //Comprovamos que el plato tenga el idioma seleccionado
    let _name = '';
    if (_price == undefined) {
      _price = 0;
    }
    if (dish.price_supplement > 0) {
      _price = _price + dish.price_supplement;
      _count = true;
    }
    if (this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, dish)) {
      if (dish.price_supplement > 0) {
        _name = this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, dish) + ' s.';
      } else {
        _name = this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, dish);
      }
      //caso extras
      if (this.takeawayServices.section_menu_order === this.translate.instant('general-extras-bebidas')) {
        _name = _name + ' s.'
      }
      this.takeawayServices.insertTable(_name, _price, _delete, _count, _type, _uid, _section, dish);
    } else {
      _name = 'no name - ' + _price
      this.takeawayServices.insertTable(_name, _price, _delete, _count, _type, _uid, _section, dish);
    }

    let toast = this.toastCtrl.create({
      message: _name + " " + this.translate.instant('instant-anadido-correctemente'),
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  variationDish(dish, _price, _priceHalf, _priceTapa, _type, _uid, section) {
    //Comprovamos que el plato tenga el idioma seleccionado
    if (this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, dish)) {
      var _name = this.tpvServices.nameLangSelectMenuDish(this.globals.restaurant.lang, dish);
      //caso extras
      if (this.takeawayServices.section_menu_order === this.translate.instant('general-extras-bebidas')) {
        _name = _name + ' s.'
      }

      this.navCtrl.push(VariationsDishSelectorPage, {
        name: _name,
        price: _price,
        price12: _priceHalf,
        priceTapa: _priceTapa,
        type: _type,
        uid: _uid,
        section: section,
        sender: 'takeaway',
        tags: dish.tags,
      });
    } else {
      this.navCtrl.push(VariationsDishSelectorPage, {
        name: 'no name - ' + _price,
        price: _price,
        price12: _priceHalf,
        priceTapa: _priceTapa,
        type: _type,
        uid: _uid,
        section: section,
        sender: 'takeaway',
        tags: dish.tags,
      });
    }

  }

  variationProduct(product, pvp, pvp2, pvp3, _type, _uid, section) {
    if (!pvp2) {
      pvp2 = 0;
    }
    if (!pvp3) {
      pvp3 = 0;
    }
    //Comprovamos que el producto tenga el idioma seleccionado
    if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
      var _name = this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)
      //caso extras
      if (this.takeawayServices.section_menu_order === this.translate.instant('general-extras-bebidas')) {
        _name = _name + ' s.'
      }
      this.navCtrl.push(VariationsProductSelectorPage, {
        name: _name,
        pvp: pvp,
        pvp2: pvp2,
        pvp3: pvp3,
        type: _type,
        uid: _uid,
        section: section,
        sender: 'takeaway',
        tags: product.tags,
      });
    } else {
      this.navCtrl.push(VariationsProductSelectorPage, {
        name: 'no name - ' + pvp,
        pvp: pvp,
        pvp2: pvp2,
        pvp3: pvp3,
        type: _type,
        uid: _uid,
        section: section,
        sender: 'takeaway',
        tags: product.tags,
      });
    }

  }

  setSectionOrder(section) {
    this.takeawayServices.section_order = section;
  }

  setMenuSectionOrder(section) {
    this.takeawayServices.section_menu_order = section;
  }

  openModalVersionPro() {
    this.navCtrl.push(AddonsTriggerVersionProPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-select/takeaway-order-select-select/takeaway-order-select-select.ts